import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { startTourPerfil } from "@/tours/tourPerfil";
import { startTourEmbajador } from "@/tours/tourEmbajador";
import { startTourEmpresa } from "@/tours/tourEmpresa";
import { startTourCompartirPerfil } from "@/tours/tourCompartirPerfil";
import { startTourActivarEmpresa } from "@/tours/tourActivarEmpresa";
import { startTourCrearEvento } from "@/tours/tourCrearEvento";

const TOURS = [
  {
    id: "perfil",
    icon: "fa-solid fa-user-pen",
    title: "Completar mi Perfil",
    description:
    "Te guiamos a completar los campos esenciales: tu RUT (necesario para comprar tickets) y tu Instagram (para postularte a invitaciones en eventos).",
    start: (navigate, uid) => startTourPerfil(navigate, uid),
  },
  {
    id: "compartir-perfil",
    icon: "fa-solid fa-share-nodes",
    title: "Compartir mi Perfil",
    description:
      "Te mostramos cómo compartir el enlace de tu perfil público para que tus amigos y seguidores puedan encontrarte en AppWhoop.",
    start: (navigate, uid) => startTourCompartirPerfil(navigate, uid),
  },
  {
    id: "embajador",
    icon: "fa-solid fa-user-tie",
    title: "Activarme como Embajador",
    description:
      "Te mostramos cómo acceder al proceso de activación como embajador para que puedas ganar comisiones por cada ticket vendido con tu enlace.",
    start: (navigate, uid) => startTourEmbajador(navigate, uid),
  },
  {
    id: "empresa",
    icon: "fa-solid fa-building",
    title: "Crear mi Empresa",
    description:
      "Te mostramos cómo acceder al proceso de creación de tu empresa para que puedas publicar y gestionar tus propios eventos.",
    start: (navigate, uid) => startTourEmpresa(navigate, uid),
  },
  {
    id: "activar-empresa",
    icon: "fa-solid fa-certificate",
    title: "Activar mi Empresa",
    description:
      "Te guiamos a través del proceso de activación de tu empresa para que puedas publicar y gestionar tus propios eventos en AppWhoop.",
    start: (navigate, uid) => startTourActivarEmpresa(navigate, uid),
  },
  // {
  //   id: "crear-evento",
  //   icon: "fa-solid fa-calendar-plus",
  //   title: "Crear tu primer Evento",
  //   description:
  //     "Te guiamos paso a paso para crear y configurar tu primer evento: desde los datos básicos hasta los tipos de ticket con su precio.",
  //   start: (navigate, uid) => startTourCrearEvento(navigate, uid),
  // },
];

export default function ToursModal({ onClose }) {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const handleStartTour = (tour) => {
    onClose();
    setTimeout(() => tour.start(navigate, user.uid), 300);
  };

  return (
    <div className="bg-aw-bluedark-95 rounded-xl p-6 w-full max-w-lg inset-shadow-sm inset-shadow-aw-green shadow-sm shadow-aw-green">
      <div className="flex items-center gap-3 mb-4">
        <FontAwesomeIcon icon="fa-solid fa-clipboard-question" className="text-aw-green text-2xl" />
        <h2 className="text-xl font-semibold text-white">Ayuda Guiada</h2>
      </div>
      <p className="text-gray-400 text-sm mb-6">
        Selecciona una opción para que te guiemos paso a paso por las funcionalidades de AppWhoop.
      </p>
      <div className="space-y-3 scrollbar-box thin h-[55dvh] overflow-y-auto">
        {TOURS.map((tour) => (
          <button
            key={tour.id}
            onClick={() => handleStartTour(tour)}
            className="w-full flex items-start gap-4 p-4 rounded-lg bg-aw-bluedark hover:bg-aw-bluedark-75 transition-colors text-left border border-gray-700 hover:border-aw-green/50"
          >
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-aw-green/15 flex items-center justify-center">
              <FontAwesomeIcon icon={tour.icon} className="text-aw-green" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white font-medium text-sm">{tour.title}</p>
              <p className="text-gray-400 text-xs mt-1 leading-relaxed">{tour.description}</p>
            </div>
            <FontAwesomeIcon
              icon="fa-solid fa-chevron-right"
              className="text-gray-500 mt-1 flex-shrink-0"
            />
          </button>
        ))}
      </div>
    </div>
  );
}
